import React, { useState, useEffect } from 'react';

function Example() {
    const [content, setContent] = useState('');

    useEffect(() => {
        // Simulating fetching HTML content from the database
        const fetchedHtml = `
<style>
    /* General Layout */
    .content-wrapper {
        display: flex;
        flex-direction: row;
        margin-left: 10%;
        margin-right: 10%;
        gap: 20px;
        margin-top: 60px;
        height:100%;
    }

    .text-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height:100%;
        width:auto;
    }

    .image-content {
        flex: 1;
        display: flex;
        justify-content: center;
        height:100%;
        width:auto;

    }

    .image-content img {
        width: 100%;
        height: auto;
    }

    /* Text Block */
    .text-title {
        font-size: 30px;
        margin:0px 0px 5px 0px;
    }

    .text-meta {
        display: flex;
        justify-content: space-between;
        margin-bottom: 0px;
        flex-wrap: wrap;
        /* Allow wrapping of text content */
    }

    .text-meta p {
        margin: 0;
    }

    .text-paragraph {
        text-align: justify;
        margin-top: 40px;
    }

    .cat {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }

    /* Media Query for Small Screens */
    @media screen and (max-width: 900px) {
        .content-wrapper {
            flex-direction: column-reverse;
            /* Reverse the order to place text above image */
        }

        .image-content {
            width: 100%;
            justify-content: flex-start;
        }

        .text-paragraph {
            margin-top: 10px;
        }
    }

    @media screen and (max-width: 500px) {
        .cat {
            width: 100%;
            /* Force the second paragraph to take the full width */
            /* Optional: Add some space between the lines */
            order: 3;
            margin-top:10px;
        }

        /* Make sure Kai Starke and 13. Apr 2025 stay together in the same row */
        .text-meta {
            flex-direction: row;
            /* Ensure that they are in a row even on small screens */
            justify-content: space-between;
            align-items: center;
        }
    }
</style>

<!-- Main Content -->
<div class="content-wrapper">
    <div class="image-content">
        <img src='/news/2025/Mar/27/spieltagsankuendigung_senioren.png' alt="Spieltagsankündigung Senior:innen" />
    </div>

    <div class="text-content">
<div class="text-header">
        <h2 class="text-title">Spieltagsankündigung Senior:innen</h2>
        <div class="text-meta">
            <p class="meta-first">Kai Starke</p>
            <div class="cat">
                <p class="meta-second">Senior:innen</p>
            </div>
            <p class="meta-first">27. Mar 2025</p>
        </div>
</div>

        <div class="text-paragraph">
            <p><strong>Erste Mannschaft</strong><br/>Die Erste spielt am Sonntag auswärts gegen GW Brauweiler. Der Aufsteiger steht mit 25 Punkten derzeit auf einem soliden 8. Tabellenplatz. Hoffen wir, dass unser Team den Schwung aus den letzten Spielen mit in die Partie nehmen kann.</p>
            <p><strong>Zweite Mannschaft</strong><br/>Die zweite Mannschaft tritt als Tabellenführer der Kreisliga B bei der Zweitvertretung des SV Allner-Bödingen an. Die Gastgeber konnten die letzten vier Spiele nicht gewinnen – also eine machbare Aufgabe.</p>
        </div>
    </div>
</div>
`;
        setContent(fetchedHtml);
    }, []);

    return (
        <div>
            {/* Rendering HTML content using dangerouslySetInnerHTML */}
            <div dangerouslySetInnerHTML={{ __html: content }} />
        </div>
    );
}

export default Example;